import { useEffect, useState, type FormEvent } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "视频", to: "/video-category" },
  { label: "图片", to: "/image-category" },
  { label: "资讯", to: "/news-category" },
  { label: "社区", to: "/community" },
  { label: "关于", to: "/about" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    setMenuOpen(false);
    navigate(value ? `/search?q=${encodeURIComponent(value)}` : "/search");
  };

  return (
    <header className="sticky top-0 z-40 border-b border-background-200/80 bg-background-50/90 backdrop-blur-md">
      <div className="container-page flex h-16 items-center gap-5">
        <Link to="/" className="flex shrink-0 items-baseline gap-2">
          <span className="font-heading text-[22px] font-semibold tracking-wide text-foreground-950">
            成人<span className="text-primary-400">网</span>
          </span>
          <span className="rounded-sm border border-accent-500/60 px-1 py-px text-[10px] leading-tight text-accent-500">
            18+
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-[13.5px] transition-colors ${
                  isActive
                    ? "bg-background-100 text-foreground-950"
                    : "text-foreground-600 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2">
          <form onSubmit={handleSearch} className="hidden lg:block">
            <div className="flex h-9 items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3.5 transition-colors focus-within:border-accent-500/70">
              <i className="ri-search-line text-sm text-foreground-500"></i>
              <input
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索视频、图集、资讯…"
                aria-label="站内搜索"
                className="w-40 bg-transparent text-xs text-foreground-900 placeholder:text-foreground-500 focus:outline-none xl:w-52"
              />
            </div>
          </form>

          <button
            type="button"
            onClick={() => setMenuOpen(true)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-600 transition-colors hover:text-accent-500 md:hidden cursor-pointer"
            aria-label="打开菜单"
          >
            <i className="ri-menu-3-line text-lg"></i>
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="fixed inset-0 z-50 md:hidden">
          <div
            className="absolute inset-0 bg-background-950/70 animate-fade-in"
            onClick={() => setMenuOpen(false)}
          ></div>
          <aside className="absolute inset-y-0 right-0 flex w-[82%] max-w-[320px] flex-col overflow-y-auto border-l border-background-200 bg-background-50 p-5 animate-fade-in">
            <div className="flex items-center justify-between">
              <span className="font-heading text-lg text-foreground-950">成人网</span>
              <button
                type="button"
                onClick={() => setMenuOpen(false)}
                className="flex h-8 w-8 items-center justify-center rounded-md border border-background-300 text-foreground-500 cursor-pointer"
                aria-label="关闭菜单"
              >
                <i className="ri-close-line text-lg"></i>
              </button>
            </div>

            <form onSubmit={handleSearch} className="mt-5">
              <div className="flex h-10 items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3.5">
                <i className="ri-search-line text-sm text-foreground-500"></i>
                <input
                  value={keyword}
                  onChange={(event) => setKeyword(event.target.value)}
                  placeholder="输入关键词搜索"
                  aria-label="站内搜索"
                  className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none"
                />
              </div>
            </form>

            <nav className="mt-6 flex flex-col">
              {navItems.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  onClick={() => setMenuOpen(false)}
                  className="flex items-center justify-between border-b border-background-200 py-3.5 text-sm text-foreground-800"
                >
                  {item.label}
                  <i className="ri-arrow-right-s-line text-foreground-600"></i>
                </Link>
              ))}
            </nav>

            <p className="mt-auto pt-6 text-[11px] leading-relaxed text-foreground-500">
              本站仅面向 18 岁以上成年观众，所有内容均为演示用途。
            </p>
          </aside>
        </div>
      ) : null}
    </header>
  );
}